import useSWR from "swr";

import { type ApiError } from "../ApiError";
import * as fetcher from "../fetcher";
import { stringifyOpportunitySearchQuery } from "./search";
import type {
  CoworkerPortfolioBriefResponse,
  OpportunitiesSearchFilters,
  OpportunitiesSearchOptions,
} from "./types";

const filterPortfolioBriefKey = (
  filters: OpportunitiesSearchFilters | null
) => {
  const updatedFilters: OpportunitiesSearchFilters | null = {
    ...filters,
    projectIds: undefined,
  };

  return updatedFilters;
};

const getCoworkerPortfolioBriefKey =
  (
    filters: OpportunitiesSearchFilters | null,
    options: OpportunitiesSearchOptions
  ) =>
  (pageIndex: number) => {
    if (!filters) {
      return null;
    }

    const query = stringifyOpportunitySearchQuery(
      filterPortfolioBriefKey(filters),
      {
        ...options,
        pageIndex,
      }
    );

    return `/opportunities/brief/coworker?${query}`;
  };

export const useCoworkerPortfolioBrief = (
  filters: OpportunitiesSearchFilters | null,
  options: OpportunitiesSearchOptions
) => {
  return useSWR<CoworkerPortfolioBriefResponse, ApiError>(
    getCoworkerPortfolioBriefKey(filters, options),
    (url) => fetcher.core.get(url),
    {
      revalidateOnFocus: true,
      refreshInterval: 60 * 1000,
    }
  );
};

export const generateCoworkerPortfolioBrief = async (
  filters: OpportunitiesSearchFilters,
  options: OpportunitiesSearchOptions
) => {
  const query = stringifyOpportunitySearchQuery(
    filterPortfolioBriefKey(filters),
    options
  );

  return fetcher.core.get(`/opportunities/brief/coworker/generate?${query}`);
};
